import styled from "styled-components";

const StyledContainer = styled.div`
  align-items: center;
  border-radius: 4px;
  color: #000;
  display: flex;
  font-size: 14px;
  font-weight: 700;
  gap: 3px;
  line-height: 19px;
  padding: 2px 7px;

  &.up {
    background: #019a00;
    color: #fff;
  }

  &.down {
    background: #9a0000;
    color: #fff;
  }
`;

export default StyledContainer;
